// see design docs:
// https://app.zeplin.io/project/5ce71ea1578b652ab8cd5cdb/screen/5db1ed2257bcf62c393b6003

// primary
export const primary = {
  darkblue: '#0058a3',
  activeYellow: '#D6B900',
  brightYellow: '#FFDC00',
  deepBlue: '#006FCF',
  black: '#000000',
};

// secondary
export const secondary = {
  acceptedGreen: '#00CE9D',
  activeGreen: '#5ea555',
  accentGray01: '#F7F8F9',
  accentGray02: '#ECEDEE',
  accentGray03: '#C8C9C7',
  accentGray04: '#97999b',
  accentGray05: '#53565A',
  accentGray06: '#CCCCCC',
  errorRed01: '#D73400',
  errorRed02: '#F2E1DC',
  white: '#FFFFFF',
};

// scale
export const scale = {
  exceptional: '#4eb748',
  fair: '#F89922',
  good: '#F2EA1B',
  poor: '#CA3928',
  veryGood: '#A6CE39',
};

// typography
export const typography = {
  gray: '#8B8D8E', // typography white @todo jon to update
  disabledGray: '#C8C9C7',
  bodyBlack: '#4A4A4A',
  headingBlacker: '#1A1A1A',
};

// accent colors
export const accentColors = {
  rtpAqua: '#009BBB',
  rtpGreen: '#3F9C35',
  rtpOrange: '#FF622F',
  rtpTeal: '#6FF0E2',
};

export const colorsVTwo = {
  brand01: '#ffdc00',
  brand03: '#1b9a9d',
  darkYellow: '#f2d000',
  darkerYellow: '#e5c500',

  text01: '#2b2b2b',
  text02: '#4b4b4b',
  text03: '#727272',
  text04: '#999999',
  text05: '#006FCF',

  ui01: '#ffffff',
  ui02: '#f4f4f4',
  ui03: '#dddddd',
  ui07: '#373940',

  backgroundGray2: '#d1d1d1',
  backgroundGray3: '#c6c6c6',
  neutralBlue: '#007aff',
  neutralBlueBg: '#e7f1fe',
  alertingGreen: '#00960F',
  alertingCobalt: '#0074AD',
  errorRed: '#da1b1b',
  errorRedBg: '#fcf3f2',
  warningYellow: '#f8c438',
  warningYellowBg: '#fdf3da',
  successTealBg: '#e1f0f1',
  completedDarkBlue: '#2B73C7',
  orange: '#F8C438',
};

const panel = {
  footer: {
    foreground: secondary.white,
    background: primary.black,
  },
  header: {
    foreground: primary.black,
    background: primary.brightYellow,
  },
  navigation: {
    foreground: secondary.accentGray05,
    background: secondary.accentGray01,
    border: secondary.accentGray02,
    menu_hover: primary.black,
    toggle: secondary.accentGray04,
  },
  main: { // main content area
    foreground: typography.headingBlacker,
    background: secondary.white,
  },
  error: {
    foreground: secondary.accentGray05,
    background: 'rgba(215, 52, 0, 0.08)',
  },
};

const badge = {
  foreground: secondary.white,
  background: scale.poor,
};

const checkbox = {
  checked: primary.deepBlue,
  disabledBackground: secondary.accentGray01,
  unchecked: secondary.accentGray04,
  label: secondary.accentGray05,
  labelDisabled: typography.headingBlacker,
  labelError: secondary.errorRed01,
};

const status = {
  inactiveBg: colorsVTwo.errorRedBg,
  inactiveText: colorsVTwo.text04,
  activeBg: colorsVTwo.successTealBg,
  activeText: colorsVTwo.alertingGreen,
};

const table = {
  headerRowBackground: secondary.white,
  rowHeaderBackground: secondary.white,
  highlightRowBackground: secondary.white,
  evenRowBackground: secondary.white,
  oddRowBackground: secondary.accentGray01,
  cellBorderColor: secondary.white,
  rowHovered: '#F5F5F5',
  rowSelected: '#E4F2F3',
  rowSelectedHovered: '#deedef',
};

// @todo: give these better names
// once the design system is solidified
// currently these colors are only
// used on the dashboard
const dashboard = {
  darkBlue: '#435AA1',
  darkPurple: '#664190',
  teal: '#35A6A8',
};

const teal = {
  50: '#E4F3F3',
  100: '#BBE1E2',
  200: '#BDCDCE',
  300: '#5FB8BA',
  400: '#3DA9AC',
  500: '#1B9A9D',
  600: '#189295',
  700: '#14888B',
  800: '#107E81',
  900: '#086C6F',
  default: '#0382AA'
};

export default {
  ...primary,
  ...secondary,
  ...scale,
  ...typography,
  ...accentColors,
  ...colorsVTwo,
  panel,
  badge,
  checkbox,
  table,
  status,
  dashboard,
  teal,
};
